/**
 * Lexi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AffecterConnaissementNumeroRevatuaDto } from '../model/models';
import { ConnaissementEnteteDto } from '../model/models';
import { ConnaissementLexiResultDto } from '../model/models';
import { ConnaissementNumeroVoyageAMettreAjour } from '../model/models';
import { CreateConnaissementDto } from '../model/models';
import { FacturerConnaissementOptions } from '../model/models';
import { FacturerConnaissementResult } from '../model/models';
import { GetConnaissementResponseDto } from '../model/models';
import { GroupingInfo } from '../model/models';
import { LoadResult } from '../model/models';
import { OptionTelechargementPlusieursPdfs } from '../model/models';
import { ParametresParDefautPourCreationConnaissementDto } from '../model/models';
import { PieceEditDto } from '../model/models';
import { PieceResultDto } from '../model/models';
import { ResultatTraitementConnaissement } from '../model/models';
import { SendConnaissementTpvToRevatuaRequestDto } from '../model/models';
import { SortingInfo } from '../model/models';
import { StatutRevatua } from '../model/models';
import { SummaryInfo } from '../model/models';
import { TypeFacturation } from '../model/models';
import { TypeTelechargementPdfEnum } from '../model/models';
import { TypeUtilisateurRuunui } from '../model/models';
import { TypeVoyage } from '../model/models';
import { TypeVoyageEnum } from '../model/models';
import { UpdateConnaissementDto } from '../model/models';
import { UpdateConnaissementNombreColisDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ConnaissementsLexiClient {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param affecterConnaissementNumeroRevatuaDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public affecterNumeroRevatua(affecterConnaissementNumeroRevatuaDto: AffecterConnaissementNumeroRevatuaDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResultatTraitementConnaissement>;
    public affecterNumeroRevatua(affecterConnaissementNumeroRevatuaDto: AffecterConnaissementNumeroRevatuaDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ResultatTraitementConnaissement>>;
    public affecterNumeroRevatua(affecterConnaissementNumeroRevatuaDto: AffecterConnaissementNumeroRevatuaDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ResultatTraitementConnaissement>>;
    public affecterNumeroRevatua(affecterConnaissementNumeroRevatuaDto: AffecterConnaissementNumeroRevatuaDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (affecterConnaissementNumeroRevatuaDto === null || affecterConnaissementNumeroRevatuaDto === undefined) {
            throw new Error('Required parameter affecterConnaissementNumeroRevatuaDto was null or undefined when calling affecterNumeroRevatua.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<ResultatTraitementConnaissement>(`${this.configuration.basePath}/api/Connaissements/affecter-numero-revatua`,
            affecterConnaissementNumeroRevatuaDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementUniqueId 
     * @param motifAnnulation 
     * @param utilisateurId 
     * @param societeId 
     * @param modifierSurRevatua 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public annulerConnaissement(connaissementUniqueId?: string, motifAnnulation?: string, utilisateurId?: number, societeId?: number, modifierSurRevatua?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public annulerConnaissement(connaissementUniqueId?: string, motifAnnulation?: string, utilisateurId?: number, societeId?: number, modifierSurRevatua?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public annulerConnaissement(connaissementUniqueId?: string, motifAnnulation?: string, utilisateurId?: number, societeId?: number, modifierSurRevatua?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public annulerConnaissement(connaissementUniqueId?: string, motifAnnulation?: string, utilisateurId?: number, societeId?: number, modifierSurRevatua?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (connaissementUniqueId !== undefined && connaissementUniqueId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>connaissementUniqueId, 'connaissementUniqueId');
        }
        if (motifAnnulation !== undefined && motifAnnulation !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>motifAnnulation, 'motifAnnulation');
        }
        if (utilisateurId !== undefined && utilisateurId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utilisateurId, 'utilisateurId');
        }
        if (societeId !== undefined && societeId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>societeId, 'societeId');
        }
        if (modifierSurRevatua !== undefined && modifierSurRevatua !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>modifierSurRevatua, 'modifierSurRevatua');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.put(`${this.configuration.basePath}/api/Connaissements/annuler-connaissement`,
            null,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param facturerConnaissementOptions 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public canFacturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<FacturerConnaissementResult>;
    public canFacturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<FacturerConnaissementResult>>;
    public canFacturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<FacturerConnaissementResult>>;
    public canFacturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (facturerConnaissementOptions === null || facturerConnaissementOptions === undefined) {
            throw new Error('Required parameter facturerConnaissementOptions was null or undefined when calling canFacturer.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<FacturerConnaissementResult>(`${this.configuration.basePath}/api/Connaissements/can-facturer`,
            facturerConnaissementOptions,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param createConnaissementDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public create(createConnaissementDto: CreateConnaissementDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CreateConnaissementDto>;
    public create(createConnaissementDto: CreateConnaissementDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CreateConnaissementDto>>;
    public create(createConnaissementDto: CreateConnaissementDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CreateConnaissementDto>>;
    public create(createConnaissementDto: CreateConnaissementDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (createConnaissementDto === null || createConnaissementDto === undefined) {
            throw new Error('Required parameter createConnaissementDto was null or undefined when calling create.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<CreateConnaissementDto>(`${this.configuration.basePath}/api/Connaissements`,
            createConnaissementDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param facturerConnaissementOptions 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public facturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<PieceEditDto>>;
    public facturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<PieceEditDto>>>;
    public facturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<PieceEditDto>>>;
    public facturer(facturerConnaissementOptions: FacturerConnaissementOptions, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (facturerConnaissementOptions === null || facturerConnaissementOptions === undefined) {
            throw new Error('Required parameter facturerConnaissementOptions was null or undefined when calling facturer.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<Array<PieceEditDto>>(`${this.configuration.basePath}/api/Connaissements/facturer`,
            facturerConnaissementOptions,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param typeVoyage 
     * @param userType 
     * @param numeroVoyage 
     * @param statutPlateformes 
     * @param partenaireId 
     * @param dateDebut 
     * @param dateFin 
     * @param codeConnaissement 
     * @param dansRevatua 
     * @param transporteurCodeOuLibelle 
     * @param facture 
     * @param facturable 
     * @param navireId 
     * @param annee 
     * @param pattern 
     * @param ileDepart 
     * @param ileArrivee 
     * @param typeFacturation 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAll(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ConnaissementLexiResultDto>>;
    public getAll(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ConnaissementLexiResultDto>>>;
    public getAll(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ConnaissementLexiResultDto>>>;
    public getAll(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (typeVoyage !== undefined && typeVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeVoyage, 'TypeVoyage');
        }
        if (userType !== undefined && userType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userType, 'UserType');
        }
        if (numeroVoyage !== undefined && numeroVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>numeroVoyage, 'NumeroVoyage');
        }
        if (statutPlateformes) {
            statutPlateformes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'StatutPlateformes');
            })
        }
        if (partenaireId !== undefined && partenaireId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>partenaireId, 'PartenaireId');
        }
        if (dateDebut !== undefined && dateDebut !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateDebut, 'DateDebut');
        }
        if (dateFin !== undefined && dateFin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateFin, 'DateFin');
        }
        if (codeConnaissement !== undefined && codeConnaissement !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>codeConnaissement, 'CodeConnaissement');
        }
        if (dansRevatua !== undefined && dansRevatua !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dansRevatua, 'DansRevatua');
        }
        if (transporteurCodeOuLibelle !== undefined && transporteurCodeOuLibelle !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>transporteurCodeOuLibelle, 'TransporteurCodeOuLibelle');
        }
        if (facture !== undefined && facture !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>facture, 'Facture');
        }
        if (facturable !== undefined && facturable !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>facturable, 'Facturable');
        }
        if (navireId !== undefined && navireId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>navireId, 'NavireId');
        }
        if (annee !== undefined && annee !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>annee, 'Annee');
        }
        if (pattern !== undefined && pattern !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>pattern, 'Pattern');
        }
        if (ileDepart !== undefined && ileDepart !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>ileDepart, 'IleDepart');
        }
        if (ileArrivee !== undefined && ileArrivee !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>ileArrivee, 'IleArrivee');
        }
        if (typeFacturation !== undefined && typeFacturation !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeFacturation, 'TypeFacturation');
        }
        if (clientId !== undefined && clientId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>clientId, 'ClientId');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<ConnaissementLexiResultDto>>(`${this.configuration.basePath}/api/Connaissements`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param typeVoyage Type de voyage (Alle/InterIle/Retour)
     * @param numeroVoyage Numéro du voyage
     * @param statutPlateformes Statut revatua  SAISIE : 0 OFFICIALISE : 1 EMBARQUE : 2 EMBARQUEMENT_REFUSE : 3 ANNULE : 4 MODIFICATION : 5 TRANSFERT : 6 BROUILLON : 7 DEMANDE : 8 DEMANDE_REFUSEE : 9 OFFICIALISE_SOUS_RESERVE : 10 PRIS_EN_CHARGE : 11
     * @param partenaireId Id du client destinataire
     * @param dateDebut Date de début Filtre et récupère les connaissement dont la date de départ est supérieure à la date de début
     * @param dateFin Date de fin Filtre et récupère les connaissement dont la date de départ est inférieure à la date de fin
     * @param codeConnaissement Numéro connaissement de GESTMAR ou CodeChargeur
     * @param dansRevatua Est présent dans Revatua
     * @param transporteurCodeOuLibelle Code bo ou intitulé du transporteur
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAll2(typeVoyage?: TypeVoyageEnum, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<GetConnaissementResponseDto>>;
    public getAll2(typeVoyage?: TypeVoyageEnum, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<GetConnaissementResponseDto>>>;
    public getAll2(typeVoyage?: TypeVoyageEnum, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<GetConnaissementResponseDto>>>;
    public getAll2(typeVoyage?: TypeVoyageEnum, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (typeVoyage !== undefined && typeVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeVoyage, 'TypeVoyage');
        }
        if (numeroVoyage !== undefined && numeroVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>numeroVoyage, 'NumeroVoyage');
        }
        if (statutPlateformes) {
            statutPlateformes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'StatutPlateformes');
            })
        }
        if (partenaireId !== undefined && partenaireId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>partenaireId, 'PartenaireId');
        }
        if (dateDebut !== undefined && dateDebut !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateDebut, 'DateDebut');
        }
        if (dateFin !== undefined && dateFin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateFin, 'DateFin');
        }
        if (codeConnaissement !== undefined && codeConnaissement !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>codeConnaissement, 'CodeConnaissement');
        }
        if (dansRevatua !== undefined && dansRevatua !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dansRevatua, 'DansRevatua');
        }
        if (transporteurCodeOuLibelle !== undefined && transporteurCodeOuLibelle !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>transporteurCodeOuLibelle, 'TransporteurCodeOuLibelle');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<GetConnaissementResponseDto>>(`${this.configuration.basePath}/apipartenaire/connaissements`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementIds 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBordereauLivraisonConnaissementPdf(connaissementIds?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public getBordereauLivraisonConnaissementPdf(connaissementIds?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public getBordereauLivraisonConnaissementPdf(connaissementIds?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public getBordereauLivraisonConnaissementPdf(connaissementIds?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (connaissementIds) {
            connaissementIds.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'connaissementIds');
            })
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/Connaissements/bordereau-livraison-connaissement/pdf`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param numeroRevatua 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByNumeroRevatua(numeroRevatua: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ConnaissementLexiResultDto>;
    public getByNumeroRevatua(numeroRevatua: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ConnaissementLexiResultDto>>;
    public getByNumeroRevatua(numeroRevatua: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ConnaissementLexiResultDto>>;
    public getByNumeroRevatua(numeroRevatua: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (numeroRevatua === null || numeroRevatua === undefined) {
            throw new Error('Required parameter numeroRevatua was null or undefined when calling getByNumeroRevatua.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ConnaissementLexiResultDto>(`${this.configuration.basePath}/api/Connaissements/${encodeURIComponent(String(numeroRevatua))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param numeroRevatua 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByNumeroRevatua2(numeroRevatua: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GetConnaissementResponseDto>;
    public getByNumeroRevatua2(numeroRevatua: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GetConnaissementResponseDto>>;
    public getByNumeroRevatua2(numeroRevatua: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GetConnaissementResponseDto>>;
    public getByNumeroRevatua2(numeroRevatua: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (numeroRevatua === null || numeroRevatua === undefined) {
            throw new Error('Required parameter numeroRevatua was null or undefined when calling getByNumeroRevatua2.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GetConnaissementResponseDto>(`${this.configuration.basePath}/apipartenaire/connaissements/${encodeURIComponent(String(numeroRevatua))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param numero 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByNumeroRevatuaOrNumeroLexi(numero: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ConnaissementLexiResultDto>;
    public getByNumeroRevatuaOrNumeroLexi(numero: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ConnaissementLexiResultDto>>;
    public getByNumeroRevatuaOrNumeroLexi(numero: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ConnaissementLexiResultDto>>;
    public getByNumeroRevatuaOrNumeroLexi(numero: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (numero === null || numero === undefined) {
            throw new Error('Required parameter numero was null or undefined when calling getByNumeroRevatuaOrNumeroLexi.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ConnaissementLexiResultDto>(`${this.configuration.basePath}/api/Connaissements/by-numero-revatua-or-lexi/${encodeURIComponent(String(numero))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param numero 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByNumeroRevatuaOrNumeroLexi2(numero: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GetConnaissementResponseDto>;
    public getByNumeroRevatuaOrNumeroLexi2(numero: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GetConnaissementResponseDto>>;
    public getByNumeroRevatuaOrNumeroLexi2(numero: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GetConnaissementResponseDto>>;
    public getByNumeroRevatuaOrNumeroLexi2(numero: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (numero === null || numero === undefined) {
            throw new Error('Required parameter numero was null or undefined when calling getByNumeroRevatuaOrNumeroLexi2.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GetConnaissementResponseDto>(`${this.configuration.basePath}/apipartenaire/connaissements/by-numero-revatua-or-lexi/${encodeURIComponent(String(numero))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementIds 
     * @param type 
     * @param optionTelechargement 
     * @param nombreExemplaires 
     * @param forcerModeleRuunui 
     * @param inclureEtiquette 
     * @param inclureBordereauLivraison 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getConnaissementPdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public getConnaissementPdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public getConnaissementPdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public getConnaissementPdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (connaissementIds) {
            connaissementIds.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'ConnaissementIds');
            })
        }
        if (type !== undefined && type !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>type, 'Type');
        }
        if (optionTelechargement !== undefined && optionTelechargement !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>optionTelechargement, 'OptionTelechargement');
        }
        if (nombreExemplaires !== undefined && nombreExemplaires !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nombreExemplaires, 'NombreExemplaires');
        }
        if (forcerModeleRuunui !== undefined && forcerModeleRuunui !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>forcerModeleRuunui, 'ForcerModeleRuunui');
        }
        if (inclureEtiquette !== undefined && inclureEtiquette !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>inclureEtiquette, 'InclureEtiquette');
        }
        if (inclureBordereauLivraison !== undefined && inclureBordereauLivraison !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>inclureBordereauLivraison, 'InclureBordereauLivraison');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/Connaissements/pdf`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEntete(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ConnaissementEnteteDto>;
    public getEntete(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ConnaissementEnteteDto>>;
    public getEntete(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ConnaissementEnteteDto>>;
    public getEntete(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getEntete.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ConnaissementEnteteDto>(`${this.configuration.basePath}/api/Connaissements/entete/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementIds 
     * @param type 
     * @param optionTelechargement 
     * @param nombreExemplaires 
     * @param forcerModeleRuunui 
     * @param inclureEtiquette 
     * @param inclureBordereauLivraison 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEtiquettePdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public getEtiquettePdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public getEtiquettePdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public getEtiquettePdfOrZipFile(connaissementIds?: Array<string>, type?: TypeTelechargementPdfEnum, optionTelechargement?: OptionTelechargementPlusieursPdfs, nombreExemplaires?: number, forcerModeleRuunui?: boolean, inclureEtiquette?: boolean, inclureBordereauLivraison?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (connaissementIds) {
            connaissementIds.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'ConnaissementIds');
            })
        }
        if (type !== undefined && type !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>type, 'Type');
        }
        if (optionTelechargement !== undefined && optionTelechargement !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>optionTelechargement, 'OptionTelechargement');
        }
        if (nombreExemplaires !== undefined && nombreExemplaires !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nombreExemplaires, 'NombreExemplaires');
        }
        if (forcerModeleRuunui !== undefined && forcerModeleRuunui !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>forcerModeleRuunui, 'ForcerModeleRuunui');
        }
        if (inclureEtiquette !== undefined && inclureEtiquette !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>inclureEtiquette, 'InclureEtiquette');
        }
        if (inclureBordereauLivraison !== undefined && inclureBordereauLivraison !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>inclureBordereauLivraison, 'InclureBordereauLivraison');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/Connaissements/etiquettes/pdf`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementUniqueId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMontantFactureExistant(connaissementUniqueId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<number>;
    public getMontantFactureExistant(connaissementUniqueId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<number>>;
    public getMontantFactureExistant(connaissementUniqueId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<number>>;
    public getMontantFactureExistant(connaissementUniqueId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (connaissementUniqueId !== undefined && connaissementUniqueId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>connaissementUniqueId, 'connaissementUniqueId');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<number>(`${this.configuration.basePath}/api/Connaissements/montant-facture`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getParametresParDefautPourCreation(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ParametresParDefautPourCreationConnaissementDto>;
    public getParametresParDefautPourCreation(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ParametresParDefautPourCreationConnaissementDto>>;
    public getParametresParDefautPourCreation(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ParametresParDefautPourCreationConnaissementDto>>;
    public getParametresParDefautPourCreation(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ParametresParDefautPourCreationConnaissementDto>(`${this.configuration.basePath}/api/Connaissements/params-creation-connaissement`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPiecesLiees(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<PieceResultDto>>;
    public getPiecesLiees(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<PieceResultDto>>>;
    public getPiecesLiees(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<PieceResultDto>>>;
    public getPiecesLiees(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPiecesLiees.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<PieceResultDto>>(`${this.configuration.basePath}/api/Connaissements/pieces-liees/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementUniqueId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQuantiteFacturee(connaissementUniqueId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<number>;
    public getQuantiteFacturee(connaissementUniqueId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<number>>;
    public getQuantiteFacturee(connaissementUniqueId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<number>>;
    public getQuantiteFacturee(connaissementUniqueId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (connaissementUniqueId !== undefined && connaissementUniqueId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>connaissementUniqueId, 'connaissementUniqueId');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<number>(`${this.configuration.basePath}/api/Connaissements/quantite-facture`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requireTotalCount A flag indicating whether the total number of data objects is required.
     * @param requireGroupCount A flag indicating whether the number of top-level groups is required.
     * @param isCountQuery A flag indicating whether the current query is made to get the total number of data objects.
     * @param isSummaryQuery 
     * @param skip The number of data objects to be skipped from the start of the resulting set.
     * @param take The number of data objects to be loaded.
     * @param sort A sort expression.
     * @param group A group expression.
     * @param filter A filter expression.
     * @param totalSummary A total summary expression.
     * @param groupSummary A group summary expression.
     * @param select A select expression.
     * @param preSelect An array of data fields that limits the Select expression. The applied select expression is the intersection of PreSelect and Select.
     * @param remoteSelect A flag that indicates whether the LINQ provider should execute the select expression. If set to false, the select operation is performed in memory.
     * @param remoteGrouping A flag that indicates whether the LINQ provider should execute grouping. If set to false, the entire dataset is loaded and grouped in memory.
     * @param expandLinqSumType 
     * @param primaryKey An array of primary keys.
     * @param defaultSort The data field to be used for sorting by default.
     * @param stringToLower A flag that indicates whether filter expressions should include a ToLower() call that makes string comparison case-insensitive. Defaults to true for LINQ to Objects, false for any other provider.
     * @param paginateViaPrimaryKey If this flag is enabled, keys and data are loaded via separate queries. This may result in a more efficient SQL execution plan.
     * @param sortByPrimaryKey 
     * @param allowAsyncOverSync 
     * @param typeVoyage 
     * @param userType 
     * @param numeroVoyage 
     * @param statutPlateformes 
     * @param partenaireId 
     * @param dateDebut 
     * @param dateFin 
     * @param codeConnaissement 
     * @param dansRevatua 
     * @param transporteurCodeOuLibelle 
     * @param facture 
     * @param facturable 
     * @param navireId 
     * @param annee 
     * @param pattern 
     * @param ileDepart 
     * @param ileArrivee 
     * @param typeFacturation 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rechercheDxByFiltres(requireTotalCount?: boolean, requireGroupCount?: boolean, isCountQuery?: boolean, isSummaryQuery?: boolean, skip?: number, take?: number, sort?: Array<SortingInfo>, group?: Array<GroupingInfo>, filter?: Array<any>, totalSummary?: Array<SummaryInfo>, groupSummary?: Array<SummaryInfo>, select?: Array<string>, preSelect?: Array<string>, remoteSelect?: boolean, remoteGrouping?: boolean, expandLinqSumType?: boolean, primaryKey?: Array<string>, defaultSort?: string, stringToLower?: boolean, paginateViaPrimaryKey?: boolean, sortByPrimaryKey?: boolean, allowAsyncOverSync?: boolean, typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<LoadResult>>;
    public rechercheDxByFiltres(requireTotalCount?: boolean, requireGroupCount?: boolean, isCountQuery?: boolean, isSummaryQuery?: boolean, skip?: number, take?: number, sort?: Array<SortingInfo>, group?: Array<GroupingInfo>, filter?: Array<any>, totalSummary?: Array<SummaryInfo>, groupSummary?: Array<SummaryInfo>, select?: Array<string>, preSelect?: Array<string>, remoteSelect?: boolean, remoteGrouping?: boolean, expandLinqSumType?: boolean, primaryKey?: Array<string>, defaultSort?: string, stringToLower?: boolean, paginateViaPrimaryKey?: boolean, sortByPrimaryKey?: boolean, allowAsyncOverSync?: boolean, typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<LoadResult>>>;
    public rechercheDxByFiltres(requireTotalCount?: boolean, requireGroupCount?: boolean, isCountQuery?: boolean, isSummaryQuery?: boolean, skip?: number, take?: number, sort?: Array<SortingInfo>, group?: Array<GroupingInfo>, filter?: Array<any>, totalSummary?: Array<SummaryInfo>, groupSummary?: Array<SummaryInfo>, select?: Array<string>, preSelect?: Array<string>, remoteSelect?: boolean, remoteGrouping?: boolean, expandLinqSumType?: boolean, primaryKey?: Array<string>, defaultSort?: string, stringToLower?: boolean, paginateViaPrimaryKey?: boolean, sortByPrimaryKey?: boolean, allowAsyncOverSync?: boolean, typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<LoadResult>>>;
    public rechercheDxByFiltres(requireTotalCount?: boolean, requireGroupCount?: boolean, isCountQuery?: boolean, isSummaryQuery?: boolean, skip?: number, take?: number, sort?: Array<SortingInfo>, group?: Array<GroupingInfo>, filter?: Array<any>, totalSummary?: Array<SummaryInfo>, groupSummary?: Array<SummaryInfo>, select?: Array<string>, preSelect?: Array<string>, remoteSelect?: boolean, remoteGrouping?: boolean, expandLinqSumType?: boolean, primaryKey?: Array<string>, defaultSort?: string, stringToLower?: boolean, paginateViaPrimaryKey?: boolean, sortByPrimaryKey?: boolean, allowAsyncOverSync?: boolean, typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (requireTotalCount !== undefined && requireTotalCount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>requireTotalCount, 'RequireTotalCount');
        }
        if (requireGroupCount !== undefined && requireGroupCount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>requireGroupCount, 'RequireGroupCount');
        }
        if (isCountQuery !== undefined && isCountQuery !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>isCountQuery, 'IsCountQuery');
        }
        if (isSummaryQuery !== undefined && isSummaryQuery !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>isSummaryQuery, 'IsSummaryQuery');
        }
        if (skip !== undefined && skip !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>skip, 'Skip');
        }
        if (take !== undefined && take !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>take, 'Take');
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'Sort');
            })
        }
        if (group) {
            group.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'Group');
            })
        }
        if (filter) {
            filter.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'Filter');
            })
        }
        if (totalSummary) {
            totalSummary.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'TotalSummary');
            })
        }
        if (groupSummary) {
            groupSummary.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'GroupSummary');
            })
        }
        if (select) {
            select.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'Select');
            })
        }
        if (preSelect) {
            preSelect.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'PreSelect');
            })
        }
        if (remoteSelect !== undefined && remoteSelect !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>remoteSelect, 'RemoteSelect');
        }
        if (remoteGrouping !== undefined && remoteGrouping !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>remoteGrouping, 'RemoteGrouping');
        }
        if (expandLinqSumType !== undefined && expandLinqSumType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>expandLinqSumType, 'ExpandLinqSumType');
        }
        if (primaryKey) {
            primaryKey.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'PrimaryKey');
            })
        }
        if (defaultSort !== undefined && defaultSort !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>defaultSort, 'DefaultSort');
        }
        if (stringToLower !== undefined && stringToLower !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>stringToLower, 'StringToLower');
        }
        if (paginateViaPrimaryKey !== undefined && paginateViaPrimaryKey !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>paginateViaPrimaryKey, 'PaginateViaPrimaryKey');
        }
        if (sortByPrimaryKey !== undefined && sortByPrimaryKey !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sortByPrimaryKey, 'SortByPrimaryKey');
        }
        if (allowAsyncOverSync !== undefined && allowAsyncOverSync !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>allowAsyncOverSync, 'AllowAsyncOverSync');
        }
        if (typeVoyage !== undefined && typeVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeVoyage, 'TypeVoyage');
        }
        if (userType !== undefined && userType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userType, 'UserType');
        }
        if (numeroVoyage !== undefined && numeroVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>numeroVoyage, 'NumeroVoyage');
        }
        if (statutPlateformes) {
            statutPlateformes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'StatutPlateformes');
            })
        }
        if (partenaireId !== undefined && partenaireId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>partenaireId, 'PartenaireId');
        }
        if (dateDebut !== undefined && dateDebut !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateDebut, 'DateDebut');
        }
        if (dateFin !== undefined && dateFin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateFin, 'DateFin');
        }
        if (codeConnaissement !== undefined && codeConnaissement !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>codeConnaissement, 'CodeConnaissement');
        }
        if (dansRevatua !== undefined && dansRevatua !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dansRevatua, 'DansRevatua');
        }
        if (transporteurCodeOuLibelle !== undefined && transporteurCodeOuLibelle !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>transporteurCodeOuLibelle, 'TransporteurCodeOuLibelle');
        }
        if (facture !== undefined && facture !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>facture, 'Facture');
        }
        if (facturable !== undefined && facturable !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>facturable, 'Facturable');
        }
        if (navireId !== undefined && navireId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>navireId, 'NavireId');
        }
        if (annee !== undefined && annee !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>annee, 'Annee');
        }
        if (pattern !== undefined && pattern !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>pattern, 'Pattern');
        }
        if (ileDepart !== undefined && ileDepart !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>ileDepart, 'IleDepart');
        }
        if (ileArrivee !== undefined && ileArrivee !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>ileArrivee, 'IleArrivee');
        }
        if (typeFacturation !== undefined && typeFacturation !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeFacturation, 'TypeFacturation');
        }
        if (clientId !== undefined && clientId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>clientId, 'ClientId');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<LoadResult>>(`${this.configuration.basePath}/api/Connaissements/recherche-devexpress`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param typeVoyage 
     * @param userType 
     * @param numeroVoyage 
     * @param statutPlateformes 
     * @param partenaireId 
     * @param dateDebut 
     * @param dateFin 
     * @param codeConnaissement 
     * @param dansRevatua 
     * @param transporteurCodeOuLibelle 
     * @param facture 
     * @param facturable 
     * @param navireId 
     * @param annee 
     * @param pattern 
     * @param ileDepart 
     * @param ileArrivee 
     * @param typeFacturation 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rechercheTpv(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<UpdateConnaissementDto>>;
    public rechercheTpv(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<UpdateConnaissementDto>>>;
    public rechercheTpv(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<UpdateConnaissementDto>>>;
    public rechercheTpv(typeVoyage?: TypeVoyage, userType?: TypeUtilisateurRuunui, numeroVoyage?: string, statutPlateformes?: Array<number>, partenaireId?: number, dateDebut?: string, dateFin?: string, codeConnaissement?: string, dansRevatua?: boolean, transporteurCodeOuLibelle?: string, facture?: boolean, facturable?: boolean, navireId?: number, annee?: number, pattern?: string, ileDepart?: number, ileArrivee?: number, typeFacturation?: TypeFacturation, clientId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (typeVoyage !== undefined && typeVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeVoyage, 'TypeVoyage');
        }
        if (userType !== undefined && userType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userType, 'UserType');
        }
        if (numeroVoyage !== undefined && numeroVoyage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>numeroVoyage, 'NumeroVoyage');
        }
        if (statutPlateformes) {
            statutPlateformes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'StatutPlateformes');
            })
        }
        if (partenaireId !== undefined && partenaireId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>partenaireId, 'PartenaireId');
        }
        if (dateDebut !== undefined && dateDebut !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateDebut, 'DateDebut');
        }
        if (dateFin !== undefined && dateFin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dateFin, 'DateFin');
        }
        if (codeConnaissement !== undefined && codeConnaissement !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>codeConnaissement, 'CodeConnaissement');
        }
        if (dansRevatua !== undefined && dansRevatua !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>dansRevatua, 'DansRevatua');
        }
        if (transporteurCodeOuLibelle !== undefined && transporteurCodeOuLibelle !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>transporteurCodeOuLibelle, 'TransporteurCodeOuLibelle');
        }
        if (facture !== undefined && facture !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>facture, 'Facture');
        }
        if (facturable !== undefined && facturable !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>facturable, 'Facturable');
        }
        if (navireId !== undefined && navireId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>navireId, 'NavireId');
        }
        if (annee !== undefined && annee !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>annee, 'Annee');
        }
        if (pattern !== undefined && pattern !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>pattern, 'Pattern');
        }
        if (ileDepart !== undefined && ileDepart !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>ileDepart, 'IleDepart');
        }
        if (ileArrivee !== undefined && ileArrivee !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>ileArrivee, 'IleArrivee');
        }
        if (typeFacturation !== undefined && typeFacturation !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeFacturation, 'TypeFacturation');
        }
        if (clientId !== undefined && clientId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>clientId, 'ClientId');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<UpdateConnaissementDto>>(`${this.configuration.basePath}/api/Connaissements/recherche-tpv`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param sendConnaissementTpvToRevatuaRequestDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendConnaissementArmateurToRevatuaFromTpv(sendConnaissementTpvToRevatuaRequestDto: SendConnaissementTpvToRevatuaRequestDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public sendConnaissementArmateurToRevatuaFromTpv(sendConnaissementTpvToRevatuaRequestDto: SendConnaissementTpvToRevatuaRequestDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public sendConnaissementArmateurToRevatuaFromTpv(sendConnaissementTpvToRevatuaRequestDto: SendConnaissementTpvToRevatuaRequestDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public sendConnaissementArmateurToRevatuaFromTpv(sendConnaissementTpvToRevatuaRequestDto: SendConnaissementTpvToRevatuaRequestDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {
        if (sendConnaissementTpvToRevatuaRequestDto === null || sendConnaissementTpvToRevatuaRequestDto === undefined) {
            throw new Error('Required parameter sendConnaissementTpvToRevatuaRequestDto was null or undefined when calling sendConnaissementArmateurToRevatuaFromTpv.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.configuration.basePath}/api/Connaissements/envoi-dans-revatua-from-tpv`,
            sendConnaissementTpvToRevatuaRequestDto,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementLexiResultDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBackOfficeConnaissements(connaissementLexiResultDto: Array<ConnaissementLexiResultDto>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ResultatTraitementConnaissement>>;
    public updateBackOfficeConnaissements(connaissementLexiResultDto: Array<ConnaissementLexiResultDto>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ResultatTraitementConnaissement>>>;
    public updateBackOfficeConnaissements(connaissementLexiResultDto: Array<ConnaissementLexiResultDto>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ResultatTraitementConnaissement>>>;
    public updateBackOfficeConnaissements(connaissementLexiResultDto: Array<ConnaissementLexiResultDto>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (connaissementLexiResultDto === null || connaissementLexiResultDto === undefined) {
            throw new Error('Required parameter connaissementLexiResultDto was null or undefined when calling updateBackOfficeConnaissements.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<Array<ResultatTraitementConnaissement>>(`${this.configuration.basePath}/api/Connaissements/backoffice`,
            connaissementLexiResultDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param updateConnaissementDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateConnaissement(updateConnaissementDto: UpdateConnaissementDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UpdateConnaissementDto>;
    public updateConnaissement(updateConnaissementDto: UpdateConnaissementDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UpdateConnaissementDto>>;
    public updateConnaissement(updateConnaissementDto: UpdateConnaissementDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UpdateConnaissementDto>>;
    public updateConnaissement(updateConnaissementDto: UpdateConnaissementDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (updateConnaissementDto === null || updateConnaissementDto === undefined) {
            throw new Error('Required parameter updateConnaissementDto was null or undefined when calling updateConnaissement.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<UpdateConnaissementDto>(`${this.configuration.basePath}/api/Connaissements`,
            updateConnaissementDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param connaissementEnteteDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateEntete(id: number, connaissementEnteteDto: ConnaissementEnteteDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public updateEntete(id: number, connaissementEnteteDto: ConnaissementEnteteDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public updateEntete(id: number, connaissementEnteteDto: ConnaissementEnteteDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public updateEntete(id: number, connaissementEnteteDto: ConnaissementEnteteDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateEntete.');
        }
        if (connaissementEnteteDto === null || connaissementEnteteDto === undefined) {
            throw new Error('Required parameter connaissementEnteteDto was null or undefined when calling updateEntete.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put(`${this.configuration.basePath}/api/Connaissements/entete/${encodeURIComponent(String(id))}`,
            connaissementEnteteDto,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param numeroRevatua 
     * @param updateConnaissementNombreColisDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateNombreDeColis(numeroRevatua: string, updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<string>;
    public updateNombreDeColis(numeroRevatua: string, updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<string>>;
    public updateNombreDeColis(numeroRevatua: string, updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<string>>;
    public updateNombreDeColis(numeroRevatua: string, updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (numeroRevatua === null || numeroRevatua === undefined) {
            throw new Error('Required parameter numeroRevatua was null or undefined when calling updateNombreDeColis.');
        }
        if (updateConnaissementNombreColisDto === null || updateConnaissementNombreColisDto === undefined) {
            throw new Error('Required parameter updateConnaissementNombreColisDto was null or undefined when calling updateNombreDeColis.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<string>(`${this.configuration.basePath}/api/Connaissements/${encodeURIComponent(String(numeroRevatua))}/nombre-de-colis`,
            updateConnaissementNombreColisDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param updateConnaissementNombreColisDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateNombreDeColisHorsRevatua(updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public updateNombreDeColisHorsRevatua(updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public updateNombreDeColisHorsRevatua(updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public updateNombreDeColisHorsRevatua(updateConnaissementNombreColisDto: UpdateConnaissementNombreColisDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {
        if (updateConnaissementNombreColisDto === null || updateConnaissementNombreColisDto === undefined) {
            throw new Error('Required parameter updateConnaissementNombreColisDto was null or undefined when calling updateNombreDeColisHorsRevatua.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch(`${this.configuration.basePath}/api/Connaissements/nombre-de-colis-hors-revatua`,
            updateConnaissementNombreColisDto,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param connaissementNumeroVoyageAMettreAjour 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateNumeroVoyage(connaissementNumeroVoyageAMettreAjour: Array<ConnaissementNumeroVoyageAMettreAjour>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public updateNumeroVoyage(connaissementNumeroVoyageAMettreAjour: Array<ConnaissementNumeroVoyageAMettreAjour>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public updateNumeroVoyage(connaissementNumeroVoyageAMettreAjour: Array<ConnaissementNumeroVoyageAMettreAjour>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public updateNumeroVoyage(connaissementNumeroVoyageAMettreAjour: Array<ConnaissementNumeroVoyageAMettreAjour>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {
        if (connaissementNumeroVoyageAMettreAjour === null || connaissementNumeroVoyageAMettreAjour === undefined) {
            throw new Error('Required parameter connaissementNumeroVoyageAMettreAjour was null or undefined when calling updateNumeroVoyage.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch(`${this.configuration.basePath}/api/Connaissements`,
            connaissementNumeroVoyageAMettreAjour,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param numeroRevatua 
     * @param statut 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStatut(numeroRevatua: string, statut: StatutRevatua, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<string>;
    public updateStatut(numeroRevatua: string, statut: StatutRevatua, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<string>>;
    public updateStatut(numeroRevatua: string, statut: StatutRevatua, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<string>>;
    public updateStatut(numeroRevatua: string, statut: StatutRevatua, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (numeroRevatua === null || numeroRevatua === undefined) {
            throw new Error('Required parameter numeroRevatua was null or undefined when calling updateStatut.');
        }
        if (statut === null || statut === undefined) {
            throw new Error('Required parameter statut was null or undefined when calling updateStatut.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<string>(`${this.configuration.basePath}/api/Connaissements/${encodeURIComponent(String(numeroRevatua))}/${encodeURIComponent(String(statut))}`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param numeroRevatua 
     * @param statut 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStatut2(numeroRevatua: string, statut: StatutRevatua, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<string>;
    public updateStatut2(numeroRevatua: string, statut: StatutRevatua, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<string>>;
    public updateStatut2(numeroRevatua: string, statut: StatutRevatua, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<string>>;
    public updateStatut2(numeroRevatua: string, statut: StatutRevatua, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (numeroRevatua === null || numeroRevatua === undefined) {
            throw new Error('Required parameter numeroRevatua was null or undefined when calling updateStatut2.');
        }
        if (statut === null || statut === undefined) {
            throw new Error('Required parameter statut was null or undefined when calling updateStatut2.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<string>(`${this.configuration.basePath}/apipartenaire/connaissements/${encodeURIComponent(String(numeroRevatua))}/${encodeURIComponent(String(statut))}`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
